import { Pipe, PipeTransform } from '@angular/core';

interface EditorJSBlock {
  type: string;
  data: {
    text?: string;
  };
}

interface EditorJSData {
  blocks: EditorJSBlock[];
}

@Pipe({
  name: 'editorJsPreview',
  standalone: true,
})
export class EditorJsPreviewPipe implements PipeTransform {
  transform(value: string | null | undefined, maxLength: number = 200): string {
    if (!value) {
      return '';
    }

    try {
      const data: EditorJSData = JSON.parse(value);

      if (!data.blocks || !Array.isArray(data.blocks)) {
        return '';
      }

      // Получаем только параграфы
      const paragraphs = data.blocks
        .filter(block => block.type === 'paragraph')
        .map(block => block.data.text)
        .filter(text => text) // убираем пустые параграфы
        .join('\n\n'); // соединяем параграфы с двойным переносом строки

      // Если текст короче максимальной длины, возвращаем как есть
      if (paragraphs.length <= maxLength) {
        return paragraphs;
      }

      // Учитываем три точки в максимальной длине
      const actualMaxLength = maxLength - 3;
      const truncated = paragraphs.substr(0, actualMaxLength);
      const lastSpace = truncated.lastIndexOf(' ');
      const lastNewLine = truncated.lastIndexOf('\n');

      // Используем последний перенос строки или пробел, в зависимости от того, что ближе к концу
      const lastBreak = Math.max(lastSpace, lastNewLine);

      return truncated.substr(0, lastBreak) + '...';
    } catch (e) {
      console.error('Ошибка при парсинге EditorJS JSON:', e);
      return '';
    }
  }
}
